import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/page/Home'
import Podcast from '@/page/Podcast'
import PodcastList from '@/page/PodcastList'
import Live from '@/page/Live'
import Detail from '@/page/Detail'
import ColumnHome from '@/page/ColumnHome'
import ColumnList from '@/page/ColumnList'
import Shows from '@/page/Shows'
import OtherShows from '@/page/OtherShows'
import LaneList from '@/page/LaneList'
import About from '@/page/About'
import Jobs from '@/page/Jobs'
import Contact from '@/page/Contact'
import Privacy from '@/page/Privacy'
//privacy

Vue.use(Router)

export default new Router({
  mode: 'history',
  scrollBehavior(to, from, savedPosition) {  //设置跳转到新页面顶部
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  },
  routes: [
    {
      path: '/',//首页
      name: 'Home',
      component: Home,
      meta:{
        keepAlive:false,
      }
    },
    {
      path: '/podcast',//podcast页
      // redirect:'live',
      name: 'Podcast',
      component: Podcast,
      meta:{
        keepAlive:false,
      }
    },
    {
      path: '/podcast/:pId',//podcast其他选项页
      // redirect:'live',
      name: 'PodcastList',
      component: PodcastList,
      meta:{
        keepAlive:false,
      }
    },
    {
      path: '/live',//live直播页
      name: 'Live',
      component: Live,
      meta: {
        keepAlive: false, // 需要缓存
      }
    },
    {
      path: '/detail/:type/:newsId',//详情页
      name: 'Detail',
      component: Detail,
      meta:{
        keepAlive:false,
      }
    },
    {
      path: '/columnHome',//栏目首页
      name: 'ColumnHome',
      component: ColumnHome,
      meta:{
        keepAlive:false,
      }
    },
    {
      path: '/columnList/:type/:newsId',//栏目列表页
      name: 'ColumnList',
      component: ColumnList,
      meta:{
        keepAlive:false,
      }
    },
    {
      path: '/shows',//节目单
      name: 'Shows',
      component: Shows,
      meta:{
        keepAlive:false,
      }
    },
    {
      path: '/shows/:showsId',//节目单
      name: 'OtherShows',
      component: OtherShows,
      meta:{
        keepAlive:false,
      }
    },
    {
      path: '/laneList/:type/:newsId',//泳道列表页
      name: 'LaneList',
      component: LaneList,
      meta:{
        keepAlive:false,
      }
    },
    {
      path: '/general/about',//About EZFM
      name: 'About',
      component: About,
      meta:{
        keepAlive:false,
      }
    },
    {
      path: '/general/jobs',//About JOBS
      name: 'Jobs',
      component: Jobs,
      meta:{
        keepAlive:false,
      }
    },
    {
      path: '/general/contact',// contact
      name: 'Contact',
      component: Contact,
      meta:{
        keepAlive:false,
      }
    },
    {
      path: '/general/privacy',// Privacy
      name: 'Privacy',
      component: Privacy,
      meta:{
        keepAlive:false,
      }
    },
    // Privacy
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js